import {
  getRetailStoreDataError,
  getRetailStoreDataPending,
  getRetailStoreDataSuccess,
} from './index';
import config from '../../oktaConfig';

function getRetailStoresData(accessToken) {
  return dispatch => {
    const geos = ['NA', 'EMEA', 'APLA', 'GC'];

    // Dispatch pending for all geos
    geos.forEach(geo => {
      dispatch(getRetailStoreDataPending(geo));
    });

    // Create parallel API calls for all geos
    const apiCalls = geos.map(geo =>
      fetch(config.resourceServer.insightsApiUrlRetailDevices + `?Geo=${geo}&brand=Nike`, {
        mode: 'cors',
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then(response => {
          if (!response.ok) {
            return Promise.reject({geo, error: response});
          }
          return response.json();
        })
        .then(data => {
          dispatch(getRetailStoreDataSuccess(geo, data));
          return {geo, data};
        })
        .catch(err => {
          dispatch(getRetailStoreDataError(geo, err));
          console.error(`Error fetching data for ${geo}:`, err);
        })
    );

    // Optional: Wait for all to complete
    return Promise.all(apiCalls);
  };
}

export default getRetailStoresData;
